import React, { useEffect, useState } from 'react'
import { Settings } from '@material-ui/icons'
import { Formik } from 'formik'
import { Card, Container, Row, Col, Form, Button } from 'react-bootstrap'

export default function Config() {

  const _handleSubmit = values => {

  }

  useEffect(() => {

  },[])

  return (
    <Container>
      <Row className="mt-4">
        <Settings className="icon-title" />
        <h5 className="title-dashboard">Config</h5>
      </Row>
      <Row>
        <Card className='card-dashboard shadow bg-white rounded m-2 col-12'>
          <Card.Body>
            <Formik
              enableReinitialize={true}
              onSubmit={_handleSubmit}
              initialValues={{
                release: false,
                release_send_nf: false
              }}
            >
              {({ handleSubmit, handleChange, setFieldValue, values }) => (
                <Form onSubmit={handleSubmit}>
                  <Row className='mb-5'>
                    <Col md="3">
                      <Form.Group>
                        <Form.Label>Liberar Sistema:</Form.Label>
                        <Form.Check
                          onChange={(e) => setFieldValue("release", e.currentTarget.checked)}
                          checked={values.release}
                          name="release"
                          id="release-switch"
                          type="switch"
                          label={values.release ? "Sim" : "Não"}
                        />
                      </Form.Group>
                    </Col>
                    <Col md="6">
                      <Form.Group>
                        <Form.Label>Liberar Envio de NFs:</Form.Label>
                        <Form.Check
                          onChange={(e) => setFieldValue("release_send_nf", e.currentTarget.checked)}
                          checked={values.release_send_nf}
                          name="release_send_nf"
                          id="release_send_nf-switch"
                          type="switch"
                          label={values.release_send_nf ? "Sim" : "Não"}
                        />
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <Button variant="success" type="submit">Salvar</Button>
                    </Col>
                  </Row>
                </Form>
              )}
            </Formik>
          </Card.Body>
        </Card>
      </Row>
    </Container>
  )
}